Backgrounds = require 'data/backgrounds'
React = require 'react'
_ = require 'underscore'
track = require 'debug/track'

colors = []

for name, data of Backgrounds
  if data.type == 'default'
    colors = colors.concat({ key: name, name, color: data.color })

Color = ({ setBackgroundColor, name, color }) ->
  React.createElement(
    'div'
    {
      onClick: ->
        track('Board Menu', 'Change Background', name)
        setBackgroundColor name, color
      className: 'board-backgrounds-section-tile'
    }
    React.createElement 'div', {
      className: 'image'
      style: {
        backgroundColor: color
      }
    }
  )

module.exports = class extends React.Component
  displayName: 'ColorsView'

  render: ->
    { setBackgroundColor } = @props

    React.createElement(
      'div'
      {}
      colors.map (colorData) ->
        React.createElement Color, _.extend({ setBackgroundColor }, colorData)
    )



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/change-board-background-colors-component-view.coffee